import { FileStoreService } from 'src/app/shared/_services/file-store.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { PrimaNotaStoreService } from '../_services/primaNota-store.service';
import { ApiRestService } from '../_services/api-rest.service';
import { ApiRestService as AziendeApiRestService } from '../../Admin/_service/api-rest.service';
import { Component, OnInit } from '@angular/core';
import { Spesa } from '../Models/Spesa';
import { ActivatedRoute, Router } from '@angular/router';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { Categorie } from 'src/app/Progetti/Models/Categorie';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {Azienda} from "../../Admin/models/Azienda";
import {AziendeStoreService} from "../../Admin/_service/aziende-store.service";

@Component({
  selector: 'app-edit-spesa',
  templateUrl: './edit-spesa.component.html'
})
export class EditSpesaComponent implements OnInit {
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  clientidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: "id",
    textField: 'nominativo',
    allowSearchFilter: true,
  };
  CategorieLineare: Categorie[] = [];
  subscriptions: Subscription = new Subscription();
  isAddable: boolean;
  isEditable: boolean;
  BackUrl: string;
  Selected: Spesa = new Spesa();
  aziende: Azienda[] = [];
  aziendeSelezionate: Azienda[] = [];
  constructor(
    private apiRest: ApiRestService,
    private aziendeApiRest: AziendeApiRestService,
    private filestore: FileStoreService,
    private primanotaStore: PrimaNotaStoreService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private aziendeStore: AziendeStoreService,
    ) { }
  ngOnInit() {
    this.aziendeStore.getListaAziende({page:0, size:10, ruolo: "F"});
    this.subscriptions.add(this.aziendeStore.$listaAziende.subscribe(data => {
      this.aziende = [];
      if (data)
        this.aziende = data.data
    }));
    this.filtroCategoria("");
    this.subscriptions.add(this.primanotaStore.$categorieCercate.subscribe(data => this.CategorieLineare = data));
    this.subscriptions.add(this.primanotaStore.$backUrl.subscribe((items) => this.BackUrl = items));
    this.subscriptions.add(this.primanotaStore.$addable.subscribe((items) => this.isAddable = items));
    this.subscriptions.add(this.primanotaStore.$editable.subscribe((items) => this.isEditable = items));
    this.subscriptions.add(this.primanotaStore.$spesa.subscribe(data => {
      if (data) {
        if(data?.fornitoreObject)
          this.aziendeSelezionate = [data?.fornitoreObject];
        this.Selected = data;
        this.filestore.SetListaFile(data.files);
        this.filestore.SelectSection('spese');
        this.Selected.data_emissione = this.datePipe.transform(data.data_emissione, 'yyyy-MM-dd');
        this.Selected.data_pagamento_e = this.datePipe.transform(data.data_pagamento_e, 'yyyy-MM-dd');
        this.Selected.data_pagamento_p = this.datePipe.transform(data.data_pagamento_p, 'yyyy-MM-dd');
      }
    }));
  }
  closeBtnClick(id:number) {
    this.primanotaStore.updateEditable(false);
    this.primanotaStore.updateAddable(false);
    this.router.navigate([this.route.snapshot.queryParams[this.BackUrl] || this.BackUrl,]);
  }
  refreshinfo(){
    this.primanotaStore.updateSpesaSelezionata(this.Selected);
  }
  saveClick(){
    if (this.Selected && this.Selected.categorie) {
      const output: number[] = [];
      this.Selected.categorie.forEach(element => {
        output.push(element.id);
      });
      this.Selected.categorie = output;
    }
    if (this.aziendeSelezionate && this.aziendeSelezionate.length>0 && this.aziendeSelezionate[0])
      this.Selected.fornitore = this.aziendeSelezionate[0].id;
    if (this.Selected.id && !isNaN(this.Selected.id)) {
      this.apiRest.updateSpesa(this.Selected).subscribe(() => this.closeBtnClick(this.Selected.categorie[0]), (error)=>this.refreshinfo() );
    } else {
      this.apiRest.addSpesa(this.Selected).subscribe(() => this.closeBtnClick(this.Selected.categorie[0]), (error)=>this.refreshinfo() );
    }
  }
  filtroCategoria(item: string) {
    this.primanotaStore.getCategorie(new RicercaPaginazione(item, undefined, undefined));
  }
  FornitoreChanged(){
    if (this.aziendeSelezionate && this.aziendeSelezionate.length>0 && this.aziendeSelezionate[0])
      this.aziendeApiRest.getInfoAziende(this.aziendeSelezionate[0]).subscribe(data=>{
        this.Selected.nominativo = data.nominativo;
        this.Selected.indirizzo = data.indirizzo;
        this.Selected.cap = data.cap;
        this.Selected.citta = data.citta;
        this.Selected.provincia = data.provincia;
        this.Selected.nazione = data.nazione;
        this.Selected.piva = data.piva;
        this.Selected.cf = data.cf;
      })

  }
}
